import WordingMixin from '@/mixins/Wording'
import EventHubMixin from '@/mixins/EventHub'

import AppAnimatedText from '@/components/app-animated-text/'

export default
{
    name: 'app-page-menu',

    mixins:
    [
        WordingMixin,
        EventHubMixin
    ],

    components:
    {
        AppAnimatedText
    },

    data()
    {
        return {
            isTitleVisible: false,
            textDuration: 1
        }
    },

    mounted()
    {
        this.isTitleVisible = true

        window.setTimeout(() =>
        {
            this.textDuration = 0.5
        }, 2000)
    },

    methods:
    {
        onButtonMouseEnter(_event)
        {
            this.$eventHub.$emit('grid.focusItem', _event.target)
        },

        onButtonMouseLeave()
        {
            this.$eventHub.$emit('grid.unfocusItem')
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/app-page-menu/script.js